import React, { ChangeEvent, ReactElement } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box } from "@mui/material";
import { Search } from "../CommonComponents";
import "./styling/heading.css";

interface PageHeaderProps {
  defaultText?: string;
  text: string;
  icon: ReactElement<typeof FontAwesomeIcon>;
  searchQuery: string;
  setSearchQuery: (searchQuery: string) => void;
}

export function PageHeader({ text, icon, setSearchQuery }: PageHeaderProps) {
  const handleSearch = (event: ChangeEvent<HTMLInputElement>) => {
    console.log("testing2");
    setSearchQuery(event.target.value);
  };

  return (
    <Box className="header-container">
      <h1 className="page-header">
        {icon}
        {text}
      </h1>
      <Search handleSearch={handleSearch} filterElement="articleCard" />
    </Box>
  );
}
